import { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import IconMenu from 'beam/dist/IconMenu'
import { MenuItem } from 'beam/dist/Menu'
import { ListItemText } from 'beam/dist/List'
import ReactToPrint from 'react-to-print'
import { withStyles } from 'beam/dist/styles'
import ChatContent from './ChatContent'
import ErrorBoundary from '../ErrorBoundary'
import { OrganizationContext } from '../../../Common/Organization/organization-context'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-ChatPanel-'

const styles = theme => ({
  panelBody: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
  },
})

class ChatPanel extends Component {

  state = {
    isSearchOpen: false,
  }

  printRef = createRef()

  createOpenSearchHandler(preOpenHandler = () => {}) {
    return () => {
      preOpenHandler()
      this.setState({ isSearchOpen: true })
    }
  }

  closeSearch() {
    this.setState({ isSearchOpen: false })
  }

  render() {

    const { classes, t, ...contentProps } = this.props
    const { loading, error } = contentProps

    const noBubbles = loading || error

    return (
      <Panel
        dense
        title={this.props.contactType === 'SMS' ? t('smsTranscript') : this.props.contactType === 'EMAIL' ? t('emailThread') : t('chatTranscript')}
        titleIcon={<BeamIcon>ChatOutline</BeamIcon>}
        variant="light"
        classes={{ body: classes.panelBody }}
        dataTestId={`${dataTestIdPrefix}panel`}
        headerTestId={`${dataTestIdPrefix}panel-heading`}
        headerActions={
          !noBubbles && (
            <IconMenu
              renderItems={closeMenu => [
                <MenuItem key="find" dense onClick={this.createOpenSearchHandler(closeMenu())}>
                  <ListItemText primary={t('find')} />
                </MenuItem>,
                <ReactToPrint
                  key="print"
                  trigger={() => (
                    <MenuItem dense>
                      <ListItemText primary={t('print')} />
                    </MenuItem>
                  )}
                  onBeforePrint={closeMenu()}
                  content={() => this.printRef.current}
                />,
              ]}
            />
          )
        }
      >
        <OrganizationContext.Consumer>
          {orgCtx => {
            return (
              <ErrorBoundary key={contentProps.ccrid}>
                <ChatContent
                  printRef={this.printRef}
                  isSearchOpen={this.state.isSearchOpen}
                  closeSearch={this.closeSearch.bind(this)}
                  orgAgents={orgCtx.agentData}
                  {...contentProps}
                />
              </ErrorBoundary>
            )
          }}
        </OrganizationContext.Consumer>

      </Panel>
    )
  }
}

// Validate the props passed to the component
ChatPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  ccrid: PropTypes.number,
  contactType: PropTypes.oneOf(['CHAT', 'SMS']),
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
}

export { ChatPanel as UnstyledChatPanel }
export default withStyles(styles)(withTranslation()(ChatPanel))
